<template>
    <div class="Userportrait">
        <div class="content">
            <div class="left">
                <p class="title">基本信息</p>
                <div class="info">
                    <div class="other1">
                        <label>{{usersummary.realName}}</label>
                        <label>{{usersummary.sex}}</label>
                        <label>{{usersummary.ages}}岁</label>
                        <label>{{usersummary.profName}}</label>
                    </div>
                    <div class="other2">
                        <p>
                            <span><i class="icon1"></i>学历：{{usersummary.degree}}</span>
                            <span><i class="icon2"></i>婚姻：{{usersummary.marriageState}}</span>
                        </p>
                        <p style="padding-top: 10px;">
                            <span><i class="icon3"></i>民族：{{usersummary.nation}}</span>
                            <span><i class="icon4"></i>籍贯：{{usersummary.nativeplace}}</span>
                        </p>
                    </div>
                    <p class="item">
                        <span>联系电话</span>
                        <span>{{usersummary.phone}}</span>
                    </p>
                    <p class="item">
                        <span>紧急联系人姓名</span>
                        <span>{{usersummary.emergencyName}}</span>
                    </p>
                    <p class="item">
                        <span>紧急联系人关系</span>
                        <span>{{usersummary.emergencyRelation}}</span>
                    </p>
                    <p class="item">
                        <span>紧急联系人联系电话</span>
                        <span>{{usersummary.emergencyRelation}}</span>
                    </p>
                </div>

                <p class="title">圈子</p>
                <div class="relationship">
                    <div class="item">
                        <span>我加入的</span>
                        <span>
                            <label v-for="(item,index) in usersummary.myAttendEvents" v-if="index<2">{{item.subject+'、'}}</label>
                        </span>
                        
                    </div>
                    <div class="item">
                        <span>我感兴趣的</span>
                        <span>
                            <label v-for="(item,index) in usersummary.tgEventLikeTransponds" v-if="index<2">{{item.subject+'、'}}</label>
                        </span>
                        
                    </div>
                    <div class="item">
                        <span>我创建的</span>
                        <span>
                            <label v-for="(item,index) in usersummary.myCreateCircles" v-if="index<2">{{item.circleName+'、'}}</label>
                        </span>
                    </div>
                </div>

                <!-- <p class="title" style="margin-top: 20px;">人物关系</p>
                <div class="relationship">
                    <div class="item">
                        <span>哥哥：金吒</span>
                        <span>同学：杨戬</span>
                    </div>
                    <div class="item">
                        <span>女友：嫦娥</span>
                        <span>同事：吴刚</span>
                    </div>
                </div> -->
            </div>


            <!-- 中间 -->
            <div class="middle">
                <div class="middle_img">
                    <span class="infoimg">
                        <i class="steep"></i>
                        <i class="bias"></i>
                    </span>
                    <span class="Preview">
                        <i class="steep"></i>
                        <i class="bias"></i>
                    </span>
                    <span class="relationship">
                        <i class="steep"></i>
                        <i class="bias"></i>
                    </span>
                    <span class="multiple">
                        <i class="steep"></i>
                        <i class="bias"></i>
                    </span>
                </div>
            </div>

            <!-- 右边 -->
            <div class="right">
                <p class="title">数据浏览</p>
                <div class="item" style="border-color: #2561ED;">
                    <span style="margin-top: 5px;display: inline-block;"><i class="icon icon5"></i>心理测评</span>
                    <label class="blue totalnum">测评总次数： {{usersummary.testCount}}次</label>
                    <p style="padding-top: 14px;" v-for="(item,index) in usersummary.testResults" v-if="index<2">测评量表：{{ item.paperName }} {{item.paperScoreS}}分 <span class="report blue blue_bg" @click="$router.push('/Visitors/ReportShow?PaperResultID='+item.paperResultID)">查看报告</span></p>
                    <el-button type="text" class="blue" @click="$router.push('/visitors/Already_ltest')">查看全部</el-button>
                </div>
                <div class="item" style="border-color: #49B307;">
                    <span style="margin-top: 5px;display: inline-block;"><i class="icon icon6"></i>心理咨询</span>
                    <label class="green totalnum">咨询总次数：{{usersummary.consultCount}}次</label>
                    <p style="padding-top: 14px;" class="subject">咨询主题：<span v-for="item in usersummary.consultTheme">{{item}}</span></p>
                    <p style="padding-top: 14px;">个人问题描述：<span v-for="item in usersummary.consultQuestion">{{item}} </span></p>
                    <el-button type="text" class="green" @click="$router.push('/Consultant/AppointmentList')">查看全部</el-button>
                </div>
                <div class="item" style="border-color: #FF6666;">
                    <span style="margin-top: 5px;display: inline-block;"><i class="icon icon7"></i>认知训练</span>
                    <label class="pink totalnum">训练总次数：5次</label>
                    <div class="cognition">
                        <div class="items"><label>观察力训练次数:</label><span>1次</span></div>
                        <div class="items"><label>思维能力训练次数:</label><span>1次</span></div>
                    </div>
                    <div class="cognition">
                        <div class="items"><label>反应能力训练次数:</label><span>1次</span></div>
                        <div class="items"><label>注意力训练次数:</label><span>1次</span></div>
                    </div>
                    <el-button type="text" class="pink">查看全部</el-button>
                </div>
                <div class="item" style="border-color: #FF9900;">
                    <span style="margin-top: 5px;display: inline-block;"><i class="icon icon8"></i>心理科普</span>
                    <label class="orange totalnum">文章查看总次数：{{usersummary.articleViewCount}}次</label>
                    <div class="articleitem" style="padding-top: 14px;"><label>浏览最多的主题：</label>{{ usersummary.maxViewTopic }}</div>
                    <div class="articleitem" style="padding-top: 14px;">
                        <label>浏览的文章：</label>
                        <div>
                            <span v-for="(item,index) in usersummary.viewArticles" v-if="index<2">{{ item }}</span>
                        </div>
                    </div>
                    <el-button type="text" class="orange">查看全部</el-button>
                </div>
            </div>
        </div>
        <div class="fotter">
            <div class="left">
                <div class="usertags">
                    <el-button type="primary" plain round style="width: 100%;color: #2561ED;border-color: #2561ED;background:none;margin-bottom:10px;">用户标签</el-button>
                    <div style="min-height: 105px;">
                        <span :class="index==0?'blue':index==1?'green':index==2?'orange':'blue'" v-for="(item,index) in usersummary.psyProfilCharacter" v-if="index<4">{{ item.factorName}}</span>
                    </div>
                    <p>······</p>
                </div>
                <div class="Psychologicalsituation">
                    <el-button type="primary " plain round style="color: #2561ED;border-color: #2561ED;background:none;margin-bottom:10px;">总体心理情况</el-button>
                    <div style="min-height:105px;" v-html="usersummary.eqresult+'<br/>'+usersummary.iqresult">
                    </div>
                    <p>······</p>
                </div>
            </div>
            <div class="tableaudetail">
                <p style="font-size: 22px;color: #000;font-weight: bold;padding-bottom: 20px;">综合画像</p>
                <div class="tableaudetail_img" @click="$router.push('ImageDetails')">
                    <i style="width: 28px;display: inline-block;margin-top:45px;"><img src="@/assets/Userportrait/img1.png"></i>
                    <p>画像详情</p>
                </div>
            </div>
            <div class="right">
                <div class="MentalHealth">
                    <el-button type="primary" plain round style="width: 100%;color: #49B307;border-color: #49B307;background:none;margin-bottom:10px;">心理健康情况</el-button>
                    <div style="min-height: 105px;">
                        <p class="items" v-for="(item,index) in usersummary.psyProfilHealth" v-if="index<4">{{item.factorName+':'+item.resultGrade}}</p>
                    </div>
                    <p>······</p>
                </div>
                <div class="preference">
                    <el-button type="primary" plain round style="width: 100%;color: #CC4949;border-color: #CC4949;background:none;margin-bottom:10px;">偏好特征</el-button>
                    <div style="height: 105px;">
                        <p class="items" v-for="(item,index) in usersummary.psyProfilPreference" v-if="index<4">{{item.dropKeyContent+':'+item.readQnty*10}}%</p>
                    </div>
                    <p>······</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name:'Userportrait',
        data() {
            return {
                userID:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
                usersummary:''
            }
        },
        created() {
            this.getusersummary();
        },
        methods: {
            getusersummary(){
                this.$Http_Post('/kg/profil/getusersummary',{userID:this.userID}).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.usersummary=res.Data;
                    }
                })
            }
        },
    }
</script>
<style scoped>
img{width: 100%;display: block;}
.Userportrait{background: radial-gradient(50% 50%, rgba(244, 248, 251, 1) 35.42%, rgba(217, 230, 250, 1) 100%);min-width: 1200px;padding: 0 0 40px;}
.Userportrait .content{display: flex;padding:40px 33px 10px;}
.Userportrait .content .middle{flex: 1;margin-top:82px;position: relative;}
.Userportrait .bias{width:1px;height: 90px;background:#2561ED;display: inline-block;}
.Userportrait .steep{width: calc(50% - 120px);height: 1px;background:#2561ED;display: inline-block;min-width:75px;}
.Userportrait .content .middle .middle_img{width: 239px;height:549px;margin: auto;background: url("../../../assets/Userportrait/img6.png") no-repeat 100%;background-size: 100%;}
.Userportrait .content .middle .middle_img .infoimg{display: inline-block;position: absolute;top:-86px;left:10px;height:100px;width:100%;}
.Userportrait .content .middle .middle_img .infoimg .bias{transform: rotate(-30deg);float: left;margin:15px 0 0 22px;}
.Userportrait .content .middle .middle_img .infoimg .steep{float: left;position: relative;top:20px;}
.Userportrait .content .middle .middle_img .infoimg .steep::after{content: '';width:8px;height:8px;border-radius: 50%;background:#2561ED;display: inline-block;position: absolute;top:-4px;}
.Userportrait .content .middle .middle_img .Preview{display: inline-block;position: absolute;top:-86px;right:10px;height:100px;width:100%;}
.Userportrait .content .middle .middle_img .Preview .bias{transform: rotate(30deg);float: right;margin:15px 22px 0 0;}
.Userportrait .content .middle .middle_img .Preview .steep{float: right;position: relative;top:20px;}
.Userportrait .content .middle .middle_img .Preview .steep::before{content: '';width:8px;height:8px;border-radius: 50%;background:#2561ED;display: inline-block;position: absolute;top:-4px;right: 0;}
.Userportrait .content .middle .middle_img .relationship{display: inline-block;position: absolute;top:445px;left:10px;height:100px;width:100%;}
.Userportrait .content .middle .middle_img .relationship .bias{transform: rotate(30deg);float: left;position: relative;top:-64px;left:22px;}
.Userportrait .content .middle .middle_img .relationship .steep{float: left;position: relative;top:20px;min-width: 60px;}
.Userportrait .content .middle .middle_img .relationship .steep::before{content: '';width:8px;height:8px;border-radius: 50%;background:#2561ED;display: inline-block;position: absolute;top:-4px;left: 0;}
.Userportrait .content .middle .middle_img .multiple{display: inline-block;position: absolute;bottom:0;left:50%;height:100px;width:113px;margin-left: -56.5px;text-align: center;}
.Userportrait .content .middle .middle_img .multiple .bias{margin-top: -5px;position: relative;}
.Userportrait .content .middle .middle_img .multiple .bias::after{content: '';width:8px;height:8px;border-radius: 50%;background:#2561ED;display: inline-block;position: absolute;bottom:0;left: -4px;}
.Userportrait .content .middle .middle_img .multiple .steep{width: 113px;}
.Userportrait .left{width: 390px;margin-bottom: 100px;}
.Userportrait .left .title{font-size: 22px;font-weight: bold;text-align: right;padding-bottom: 20px;}
.Userportrait .left .title::after{content:'';width: 4px;height:22px;background:#2561ED;display: inline-block;position: relative;top: 3px;margin-left: 10px;}
.Userportrait .left .info{background: #fff;border-radius: 4px;margin-bottom:30px;}
.Userportrait .left .info .other1{display: flex;justify-content: center;align-items: center;border-bottom:1px solid #E3E3E3;}
.Userportrait .left .info .other2{padding:15px 16px;border-bottom:1px solid #E3E3E3;}
.Userportrait .left .info .other2 span{width:50%;display: inline-block;}
.Userportrait .left .info .other2 span .icon1{background:url("../../../assets/Userportrait/img17.png") no-repeat 100%;background-size: 100%;}
.Userportrait .left .info .other2 span .icon2{background:url("../../../assets/Userportrait/img3.png") no-repeat 100%;background-size: 100%;}
.Userportrait .left .info .other2 span .icon3{background:url("../../../assets/Userportrait/img5.png") no-repeat 100%;background-size: 100%;}
.Userportrait .left .info .other2 span .icon4{background:url("../../../assets/Userportrait/img4.png") no-repeat 100%;background-size: 100%;}
.Userportrait .left .info .other2 span i{width: 16px;height: 16px;display: inline-block;margin-right:5px;position: relative;top: 3px;}
.Userportrait .left .info .item{border-bottom:1px solid #E3E3E3;display:flex;}
.Userportrait .left .info .item span{flex: 1;padding: 15px 20px;text-align: end;}
.Userportrait .left .info .item span:last-child{border-left:1px solid #E3E3E3;text-align:start;}
.Userportrait .left .info label{flex: 1;text-align: center;padding:25px 0;display: flex;align-items: center;justify-content: center;}
.Userportrait .left .info label::before{content:'';width: 6px;height:6px;background: #2561ED;display:inline-block;border-radius: 50%;margin-right: 10px;}
.Userportrait .left .info label:nth-child(2)::before{background: #FF9900;}
.Userportrait .left .info label:nth-child(3)::before{background: #FF6666;}
.Userportrait .left .info label:nth-child(4)::before{background: #92D9A1;}
.Userportrait .left .relationship{background: #fff;border-radius: 4px;}
.Userportrait .left .relationship .item{border-bottom:1px solid #E3E3E3;display:flex;}
.Userportrait .left .relationship .item span{flex: 1;padding: 15px 20px;text-align: end;}
.Userportrait .left .relationship .item span:last-child{border-left:1px solid #E3E3E3;text-align:start;}
.Userportrait .right{width: 390px;}
.Userportrait .right .title{font-size:22px;font-weight: bold;padding-bottom: 20px;}
.Userportrait .right .title::before{content:'';width: 4px;height:22px;background:#2561ED;display: inline-block;position: relative;top: 3px;margin-right: 10px;}
.Userportrait .right .item{background:#fff;padding:16px 16px 8px;border-left: 4px solid #fff;margin-bottom:8px;}
.Userportrait .right .item .report{border-radius: 200px;padding:4px 8px;font-size: 12px;margin-left: 20px;cursor: pointer;}
.Userportrait .right .item .icon{width: 16px;height: 16px;display: inline-block;margin-right:5px;position: relative;top: 3px;}
.Userportrait .right .item .icon5{background:url("../../../assets/Userportrait/img12.png") no-repeat 100%;background-size: 100%;}
.Userportrait .right .item .icon6{background:url("../../../assets/Userportrait/img15.png") no-repeat 100%;background-size: 100%;}
.Userportrait .right .item .icon7{background:url("../../../assets/Userportrait/img10.png") no-repeat 100%;background-size: 100%;}
.Userportrait .right .item .icon8{background:url("../../../assets/Userportrait/img14.png") no-repeat 100%;background-size: 100%;}
.Userportrait .right .item .cognition{display: flex;width: 100%;margin: 0 0 5px;}
.Userportrait .right .item .cognition .items{flex: 1;padding:5px 0 0;}
.Userportrait .right .item .cognition .items label{width: 125px;display: inline-block;}
.Userportrait .right .item .cognition .items span{border-radius: 50px;padding: 2px 5px;margin: 0 5px 5px;background: rgba(255, 102, 102, 0.1);color: #FF6666;}
.Userportrait .right .item .totalnum{font-size:22px;float: right;}
.Userportrait .right .item .subject span{background:rgb(73 179 7 / 10%);color: #49B307;padding: 3px 8px;border-radius: 200px;margin-left: 10px;}
.Userportrait .right .item .articleitem{display:flex;}
.Userportrait .right .item .articleitem label{width: 150px;text-align: right;flex: none;}
.Userportrait .right .item .articleitem div{display: flex;flex-direction: column;}
.Userportrait .right .item .articleitem span{background: rgba(255, 153, 0, 0.1);color: #FF9900;font-size: 14px;padding: 2px 5px;border-radius: 50px;margin:0 0 5px;}
.blue{color:#2561ED;display: inline-block;}
.blue_bg{background:rgba(37, 97, 237, 0.1);}
.green{color:#49B307;display: inline-block;}
.green_bg{background:rgba(73, 179, 7, 0.1);}
.pink{color:#FF6666;display: inline-block;}
.pink_bg{background:rgba(255, 102, 102, 0.1);}
.orange{color:#FF9900;display: inline-block;}
.orange_bg{background:rgba(255, 153, 0, 0.1);}
.fotter{display: flex;padding: 0 33px;}
.fotter .left,.fotter .right{display: flex;margin-top:66px;}
.fotter .usertags{width: 121px;text-align: center;margin-right: 44px;}
.fotter .usertags .item{display: flex;}
.fotter .usertags span{padding: 3px 9px;border-radius: 4px;color: #fff;margin:4px 4px;white-space: nowrap;}
.fotter .usertags span.blue{background: #2561ED;}
.fotter .usertags span.green{background:#49B307;}
.fotter .usertags span.orange{background: #FF9900;}
.fotter .Psychologicalsituation{width: 236px;}
.fotter .tableaudetail{flex: 1;text-align: center;color: #fff;}
.fotter .MentalHealth,.fotter .preference{width: 121px;margin: 0 24px;text-align: center;}
.fotter .MentalHealth .items,.fotter .preference .items{padding: 3px 0;}
.fotter .tableaudetail .tableaudetail_img{width:215px;margin: auto;height: 154px;background: url("../../../assets/Userportrait/img2.png") no-repeat;background-size: 100%;cursor: pointer;}
</style>